<template>
    <div class="n2-center-container" style="background-color:#fff; padding:10px; position: relative;">
        <div v-if="!success" style="padding:0;">
            <h4>{{ $t('pages.signup.signup') }}</h4>
            <p v-html="$t('pages.signup.signup_desc')"></p>
            <div style="max-width:600px;">
                <form-input type="text" v-model="contact.given_name" v-bind:label="$t('pages.signup.given_name')"
                    v-bind:errors="model_errors.given_name"></form-input>
                <form-input type="text" v-model="contact.family_name" v-bind:label="$t('pages.signup.family_name')"
                    v-bind:errors="model_errors.family_name"></form-input>
                <form-input type="text" v-model="contact.address.address_line_1"
                    v-bind:label="$t('pages.signup.address_line_1')"
                    v-bind:errors="model_errors.address_line_1"></form-input>
                <form-input type="text" v-model="contact.address.postal_code"
                    v-bind:label="$t('pages.signup.postal_code')" v-bind:errors="model_errors.postal_code"></form-input>
                <form-input type="text" v-model="contact.address.locality" v-bind:label="$t('pages.signup.locality')"
                    v-bind:errors="model_errors.locality"></form-input>
                <div class="n2-form-group">
                    <label class="n2-form-label">
                        {{ $t('pages.signup.country_code') }}
                    </label>

                    <app-autocomplete v-model="contact.address.country_code" v-bind:items="countries"
                        v-bind:text_field="'name'" v-bind:separator="' '" v-bind:value_field="'code'"
                        v-bind:errors="model_errors.country_code">
                    </app-autocomplete>


                </div>
                <form-input type="text" v-model="contact.phone_number" v-bind:label="$t('pages.signup.phone_number')"
                    v-bind:errors="model_errors.phone_number"></form-input>
                <form-input type="text" v-model="contact.email" v-bind:label="$t('pages.signup.email')"
                    v-bind:errors="model_errors.email"></form-input>
                <form-input type="text" v-model="contact.email_repeat" v-bind:label="$t('pages.signup.email_repeat')"
                    v-bind:errors="model_errors.email_repeat"></form-input>
                <form-input type="password" v-model="contact.password" v-bind:label="$t('pages.signup.password')"
                    v-bind:errors="model_errors.password"></form-input>
                <form-input type="password" v-model="contact.password_repeat"
                    v-bind:label="$t('pages.signup.password_repeat')"
                    v-bind:errors="model_errors.password_repeat"></form-input>
                <validation-summary v-bind:errors="model_errors"></validation-summary>
                <div class="n2-margin-top">
                    <button class="n2-button-1" v-on:click="signup">{{ $t('pages.signup.signup') }}</button>
                </div>
            </div>
        </div>
        <div v-else class="n2-text-center" style="padding:0">
            <h4>{{ $t('pages.signup.signup_success') }}</h4>
            <p>{{ $t('pages.signup.signup_success_desc') }}</p>
        </div>
        <app-loader v-bind:active="loading"></app-loader>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { CustomerService } from '../services'

import FormInput from "../components/shared/form-input.vue"
import ValidationSummary from '../components/shared/validation-summary.vue';
import AppAutocomplete from '../components/shared/autocomplete.vue'
import AppLoader from '../components/shared/loader.vue';

import country_list from '../data/country-list'

export default {
    components: { FormInput, ValidationSummary, AppAutocomplete, AppLoader },
    data: function () {
        return {
            loading:false,
            model_errors: {},
            success: false,
            contact: {
                address: {
                    country_code: 'NO'
                }
            }
        };
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
            'locale',
        ]),
        countries: function () {
            if (this.app_locale == 'no') {
                return country_list.no
            }
            else {
                return country_list.en
            }
        }
    },
    created: function () {
        this.customerService = new CustomerService()
    },
    mounted: async function () {
        //this.contact.address.country_code = 'NO'
    },
    methods: {
        validateForm: function () {
            this.model_errors = {}
            if (!this.contact.given_name) {
                this.model_errors['given_name'] = [this.$t('pages.signup.error_given_name')]
            }
            if (!this.contact.family_name) {
                this.model_errors['family_name'] = [this.$t('pages.signup.error_family_name')]
            }
            if (!this.contact.address.address_line_1) {
                this.model_errors['address_line_1'] = [this.$t('pages.signup.error_address_line_1')]
            }
            if (!this.contact.address.postal_code) {
                this.model_errors['postal_code'] = [this.$t('pages.signup.error_postal_code')]
            }
            if (!this.contact.address.locality) {
                this.model_errors['locality'] = [this.$t('pages.signup.error_locality')]
            }
            if (!this.contact.address.country_code) {
                this.model_errors['country_code'] = [this.$t('pages.signup.error_country_code')]
            }
            if (!this.contact.phone_number) {
                this.model_errors['phone_number'] = [this.$t('pages.signup.error_phone_number')]
            }
            let patternEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!patternEmail.test(this.contact.email)) {
                this.model_errors['email'] = [this.$t('pages.signup.error_email')]
            }
            var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
            if (!strongRegex.test(this.contact.password)) {
                this.model_errors['password'] = [this.$t('pages.signup.error_password')]
            }
            if (this.contact.email != this.contact.email_repeat) {
                this.model_errors['email_repeat'] = [this.$t('pages.signup.error_email_repeat')]
            }
            if (this.contact.password != this.contact.password_repeat) {
                this.model_errors['password_repeat'] = [this.$t('pages.signup.error_password_repeat')]
            }
            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        signup: async function () {
            if (!this.validateForm()) {
                return
            }
            try {
                this.loading = true;
                this.contact.email = this.contact.email.toLowerCase().trim();
                if (this.contact.phone_number) {
                    this.contact.phone_number = this.contact.phone_number.toLowerCase().trim();
                }
                await this.customerService.signup(this.contact)
                this.success = true,
                    await this.$store.dispatch('identity/signin', { email: this.contact.email.toLowerCase().trim(), password: this.contact.password });
            }
            catch (err) {
                if (err.errors && err.errors.email) {
                    this.$set(this.model_errors, 'email', [this.$t('pages.signup.error_email_exist')])
                }
            }
            finally {
                this.loading = false;
            }
        }
    }
}
</script>
<style lang="sass">
</style>
